module.exports = __webpack_public_path__ + "img/file-word.b78dce8b.svg";